import CircularProgress from "@mui/material/CircularProgress";

const CircularLoader = ({ sx = {}, iconSize = "60px" }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // height: "50vh",
        width: "100%",
        ...sx,
      }}
    >
      <CircularProgress
        size={iconSize}
        sx={{ color: "var(--palette-primary_button)" }}
      />
    </div>
  );
};
export default CircularLoader;
